module.exports = __webpack_public_path__ + "img/branch.dad5b344.gif";